export default __webpack_public_path__ + "static/media/aquo_bottle.68086bfb.scs";